// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"109":"89be64a0","662":"ad45bc52","765":"4206aa1f","931":"518c0353","960":"debb535e"}[chunkId] + ".chunk.css";
};